import { render } from "./FormCreateCompanyPrimary.vue?vue&type=template&id=e12b832a"
import script from "./FormCreateCompanyPrimary.vue?vue&type=script&lang=js"
export * from "./FormCreateCompanyPrimary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__